import React, { useContext } from "react";
import { ApplicationContext } from "./ApplicationContext";

const UserInfo = () => {
  const { userRole, loggedInClient } = useContext(ApplicationContext);

  if (!loggedInClient || Object.keys(loggedInClient).length === 0) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center p-8 bg-white rounded-lg shadow-md">
          <i className="fas fa-user-slash text-4xl text-gray-400 mb-4"></i>
          <p className="text-lg text-gray-600">Nema dostupnih podataka o korisniku</p>
        </div>
      </div>
    );
  }

  const InfoSection = ({ title, children }) => (
    <div className="bg-white rounded-lg shadow-md p-6 mb-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">{title}</h3>
      {children}
    </div>
  );

  const InfoItem = ({ label, value }) => (
    <div className="py-2 flex flex-col sm:flex-row sm:items-center border-b border-gray-100 last:border-0">
      <span className="text-sm font-medium text-gray-500 sm:w-1/3">{label}</span>
      <span className="text-sm text-gray-900 sm:w-2/3">{value}</span>
    </div>
  );

  const StatusBadge = ({ isActive }) => (
    <span className={`px-3 py-1 rounded-full text-sm font-medium ${
      isActive 
        ? 'bg-green-100 text-green-800' 
        : 'bg-red-100 text-red-800'
    }`}>
      {isActive ? 'Aktivan' : 'Neaktivan'}
    </span>
  );

  const {
    nameOfTheLegalEntity,
    city,
    address,
    pib,
    identificationNumber,
    contactPerson,
    contactNumber,
    email,
    paymentCurrency,
    customerCode,
    isActive,
    comment,
    deliveryAddressList,
    discounts,
  } = loggedInClient;

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      {/* Header */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 flex items-center">
          <i className="fas fa-user-circle text-blue-500 mr-3"></i>
          Korisnički Profil
        </h2>
        <p className="mt-2 text-gray-600">Pregled informacija o korisniku i podešavanja naloga</p>
      </div>

      {/* Main Info Section */}
      <InfoSection title="Osnovne Informacije">
        <div className="grid grid-cols-1 gap-4">
          <InfoItem label="Naziv pravnog subjekta" value={nameOfTheLegalEntity} />
          <InfoItem label="PIB" value={pib} />
          <InfoItem label="Identifikacioni broj" value={identificationNumber} />
          <InfoItem label="Kod kupca" value={customerCode} />
          <InfoItem label="Status" value={<StatusBadge isActive={isActive} />} />
          <InfoItem label="Uloga" value={userRole} />
        </div>
      </InfoSection>

      {/* Contact Info Section */}
      <InfoSection title="Kontakt Informacije">
        <div className="grid grid-cols-1 gap-4">
          <InfoItem label="Kontakt osoba" value={contactPerson} />
          <InfoItem label="Kontakt telefon" value={contactNumber} />
          <InfoItem label="Email" value={email} />
          <InfoItem label="Grad" value={city} />
          <InfoItem label="Adresa" value={address} />
        </div>
      </InfoSection>

      {/* Delivery Addresses Section */}
      <InfoSection title="Adrese za Isporuku">
        {deliveryAddressList?.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {deliveryAddressList.map((addr, index) => (
              <div 
                key={index}
                className="p-4 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-200"
              >
                <div className="flex items-start">
                  <i className="fas fa-map-marker-alt text-red-500 mt-1 mr-3"></i>
                  <span>{addr.city}, {addr.address}</span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-500 italic">Nema dostupnih adresa za isporuku</p>
        )}
      </InfoSection>

      {/* Discounts Section */}
      <InfoSection title="Popusti">
        {discounts?.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {discounts.map((discount, index) => (
              <div 
                key={index}
                className="p-4 rounded-lg bg-blue-50 hover:bg-blue-100 transition-colors duration-200"
              >
                <div className="flex items-center justify-between">
                  <span className="font-medium text-blue-900">{discount.brand.brandName}</span>
                  <span className="text-blue-800 font-bold">{discount.discount}%</span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-500 italic">Nema dostupnih popusta</p>
        )}
      </InfoSection>

      {/* Additional Info Section */}
      {comment && (
        <InfoSection title="Dodatne Informacije">
          <div className="bg-gray-50 rounded-lg p-4">
            <p className="text-gray-700 whitespace-pre-wrap">{comment}</p>
          </div>
        </InfoSection>
      )}
    </div>
  );
};

export default UserInfo;
